import { Component, OnInit, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import { DatabaseMaintenanceClient, GetIndexFragmentations } from '../../generated-client/generated-client';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable
} from '@angular/material/table';

import { DecimalPipe } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
  selector: 'da-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrl: './maintenance.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatProgressSpinner,
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow,
    MatButton,
    DecimalPipe
  ]
})
export class MaintenanceComponent implements OnInit {
  private databaseMaintenanceClient = inject(DatabaseMaintenanceClient);

  indexFragmentation = signal<GetIndexFragmentations | null>(null);
  inFlight = signal(false);

  ngOnInit(): void {
    this.refreshIndexFragmentation();
  }

  refreshIndexFragmentation(): void {
    this.inFlight.set(true);
    this.databaseMaintenanceClient.getDatabaseIndexFragmentation().subscribe(indexFragmentation => {
      this.inFlight.set(false);
      this.indexFragmentation.set(indexFragmentation);
    });
  }

  scheduleIndexRebuild(): void {
    if (this.inFlight()) {
      return;
    }

    this.inFlight.set(true);
    this.databaseMaintenanceClient.scheduleDatabaseIndexRebuild().subscribe({
      next: () => {
        this.inFlight.set(false);
      },
      error: error => {
        this.inFlight.set(false);
        console.error(error);
      }
    });
  }
}
